













import orderList from "./list.vue";
import orderLine from "./line.vue";
import { PageModule } from "@/store/module/page";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "orderlist",
  components: {
    orderList,
    orderLine,
  },
})
export default class extends Vue {
  activeName: string = "orderlist";
  created() {
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    } else {
      const cache = PageModule.pageInfo.orderManage;
      if (cache.tab) {
        this.activeName = cache.tab;
      } else {
        this.activeName = "orderlist";
        PageModule.SET_PAGE_INFO({
          name: "orderManage",
          key: "tab",
          value: "orderlist",
        });
      }
    }
    if (this.$route.query.from === "experienceToDetailed") {
      this.activeName = "orderline";
    }
  }
  tabChange(v: any) {
    PageModule.SET_PAGE_INFO({
      name: "orderManage",
      key: "tab",
      value: v.name,
    });
  }
}
